import Vue from 'vue';

const state = {
  user: null,
  sede: null,
  logged: !!window.localStorage.getItem('_token'),
  permisos: [],
  permisosLoaded: false
};

// Promesa compartida para evitar peticiones duplicadas cuando varias vistas piden los permisos a la vez
let permisosPromise = null;

const actions = {
  login: ({commit}, userInput) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('login', {user: userInput})
        .then(user => {
            window.localStorage.setItem('_token', user.body.token);
            commit('setUser');
            resolve(user);
        })
        .catch(response => {
          commit('setError', response, { root: true });
          reject(response);
        })
        .finally(() => {
          commit('stopProcessing', null, { root: true });
        })
    })
  },
  getPermisos: ({commit, state}) => {
    // Si ya se cargaron los permisos, o hay una petición en curso, la reutilizamos
    if(state.permisosLoaded) {
      return Promise.resolve();
    }
    if(permisosPromise) {
      return permisosPromise;
    }
    commit('startProcessing', null, { root: true });
    permisosPromise = new Promise((resolve, reject) => {
      Vue.http.get('user/permisos')
        .then(response => {
          commit('setPermisos', response.data.permisos);
          resolve(response);
        })
        .catch(response => {
          commit('setError', response, { root: true });
          reject(response);
        })
        .finally(() => {
          commit('stopProcessing', null, { root: true });
          permisosPromise = null;
        })
    });
    return permisosPromise;
  },
  logout: ({commit}) => {
    window.localStorage.removeItem('_token');
    commit('setUser');
    commit('docentes/restart',null,{ root: true });
    commit('agendamientos/restart',null,{ root: true });
    commit('clases/restart',null,{ root: true });
    commit('estado/restart',null,{ root: true });
    commit('estudiantes/restart',null,{ root: true });
    commit('funcionarios/restart',null,{ root: true });
    commit('grupos/restart',null,{ root: true });
    commit('indicadores/restart',null,{ root: true });
    commit('permisos/restart',null,{ root: true });
    commit('preasignaciones/restart',null,{ root: true });
    commit('progresos/restart',null,{ root: true });
    commit('salones/restart',null,{ root: true });
    commit('sedes/restart',null,{ root: true });
    commit('temas/restart',null,{ root: true });
    commit('asw/restart',null,{ root: true });
  },
  fetchSede:({commit},data) => {
    commit('startProcessing', null, { root: true });
    return new Promise((resolve, reject) => {
      Vue.http.post('sede',data).then(
        response =>{
          commit('setSede',response.data);
          resolve(response.data)
        }
      ).catch(response=>{
        commit('setError', response, { root: true });
        reject(response)
      }).finally(()=>{
        commit('stopProcessing', null, { root: true });
      })
    });
  },
};

const getters = {
  permiso: (state) => (permiso) => {
    /* if(state.user.data.grupo_id == 2){
      return true
    } */
    return state.permisos.find((element)=>{
      return element == permiso
    })

    /* return state.user.permisos.find((element)=>{
      return element == permiso
    }) */
  },
};

const mutations = {
  //establecemos el user a través del token jwt
  setUser: (state) => {
    if(window.localStorage.getItem('_token')) {
      const token = window.localStorage.getItem('_token');
      const jwtDecode = require('jwt-decode');
      state.user = jwtDecode(token);
      // state.user.permisos = JSON.parse(state.user.data.permisos)
      state.logged = true;
    } else {
      state.logged = false;
      state.user = null;
      state.permisos = [];
      state.permisosLoaded = false;
    }
  },
  setPermisos: (state, permisos) => {
    if(permisos) {
      state.permisos = permisos;
    } else {
      state.permisos = [];
    }
    state.permisosLoaded = true;
  },
  //establecemos el estado del usuario
  setLogged: (state, logged) => {
    state.logged = logged;
  },
  setSede: (state, sede) => {
    state.sede = sede;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
